import { dimensionTypes } from '../constants/retention';

export const getPercentage = (firstFragment, subsequentFragment) =>
  Math.round((subsequentFragment * 100) / firstFragment) || 0;

const getDataSource = (result) => {
  return Object.keys(result.retentionUnits)
    .map((unitLb) => {
      const mapping = { key: unitLb, date: +unitLb };
      const unitFragmentsData = result.retentionUnits[unitLb];

      for (let i = 0; i < unitFragmentsData.length; ++i) {
        mapping[i] = unitFragmentsData[i];
      }

      return mapping;
    })
    .sort((d1, d2) => +d1.key - +d2.key);
};

const getAverageData = ({ retentionUnits }) => {
  const positiveRetentionUnits = Object.values(retentionUnits).filter((u) => u[0]);
  const items = positiveRetentionUnits.reduce((result, unit) => {
    const getElementAt = (i) => result[i] || {};

    return unit.map((v, i) => ({
      value: (getElementAt(i).value || 0) + v,
    }));
  }, []);

  return items.map(({ value }, index) => {
    return {
      value,
      // процент считается от первого.
      percent: index === 0 ? 100 : getPercentage(items[0].value, value),
    };
  });
};

const getFirstColumnTitle = (dimensionType) => {
  let prefix;

  switch (dimensionType) {
    case dimensionTypes.DAILY:
      prefix = 'Day';
      break;

    case dimensionTypes.WEEKLY:
      prefix = 'Week';
      break;

    case dimensionTypes.MONTHLY:
      prefix = 'Month';
      break;

    default:
      prefix = 'Unknown';
  }

  return `${prefix} of First Event`;
};

const getSequenceColumnGroupTitle = (dimensionType) => {
  let suffix;

  switch (dimensionType) {
    case dimensionTypes.DAILY:
      suffix = 'Days';
      break;

    case dimensionTypes.WEEKLY:
      suffix = 'Weeks';
      break;

    case dimensionTypes.MONTHLY:
      suffix = 'Months';
      break;

    default:
      suffix = 'Unknown';
  }

  return `% of Users Performing Return Event - ${suffix} Later`;
};

export const prepareTableData = (result, dimensionType) => {
  if (result) {
    return {
      dataSource: getDataSource(result),
      averageData: getAverageData(result),
      firstColumnTitle: getFirstColumnTitle(dimensionType),
      sequenceColumnGroupTitle: getSequenceColumnGroupTitle(dimensionType),
    };
  }

  return null;
};
